<template>
   <CustomerServiceDetail />
</template>

<script>
import CustomerServiceDetail from "@/base/core/components/customer-service/CustomerServiceDetail.vue"
export default {
  name: "Contact",
  components: {
  CustomerServiceDetail
  },
  
};
</script>

